import script from "./SelectMultiInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMultiInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectMultiInput.vue?vue&type=style&index=0&id=5bbfc72f&lang=css"

const __exports__ = script;

export default __exports__